import AuthDataForm from "./AuthDataForm";

export default AuthDataForm;
